module.exports = __webpack_public_path__ + "static/media/im9.5dce9561.png";